import styled from 'styled-components'

import { Dropdown, TypeStyle, fromMd } from '@syconium/little-miss-figgy'

import { FavoritesButton as BaseFavoritesButton } from '../../../../../../app/_components/buttons/FavoritesButton.client'

export const ProductDetailsTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 1.45;
  text-transform: uppercase;
`

export const IntlMsgWrap = styled(ProductDetailsTitle)`
  text-align: center;
  margin: ${o => o.theme.spacing(6)};

  ${fromMd} {
    margin: ${o => o.theme.spacing(4)} 0;
  }
`

export const ProductDetailsCopy = styled.blockquote<{
  secondary?: boolean
}>`
  ${TypeStyle.css.headlineMicro}
  color: ${o => o.secondary && o.theme.color.deprecated.obsidianLighter};
  padding: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;
`

export const PromoExclusionMessage = styled(TypeStyle.BodySmall)`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  margin: ${o => o.theme.spacing(6)};

  ${fromMd} {
    margin: ${o => o.theme.spacing(6)} 0;
  }
`

export const QuantitySelectorWrapper = styled.div`
  margin-right: 8px;
`

export const StyledDropdown = styled(Dropdown)`
  height: 100%;

  > [role='button'] {
    box-sizing: border-box;
    height: 100%;
  }
`

export const WhyWeLoveDivider = styled.hr`
  border-color: ${o => o.theme.color.deprecated.stoneLight};
  border-style: solid;
  border-width: 1px 0 0;
  margin: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;
`

export const WhyWeLoveText = styled(TypeStyle.HeadlineExtraExtraSmall)`
  border-top: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  font-weight: 400;
  padding: 24px 0;
`

export const FavoritesContainer = styled.div`
  border: 1px solid #cccccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: 50px;
`

export const PDPFavoritesButton = styled(BaseFavoritesButton)`
  && {
    padding: ${o => o.theme.spacing(4)};
  }
`
